{
    "WwTkW": {
        "position": {
            "x": 5,
            "y": 4,
            "z": 1
        },
        "key": "WwTkW",
        "tag": "badspawn"
    },
    "biQA5": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "key": "biQA5",
        "tag": "badspawn"
    },
    "2_IsM": {
        "position": {
            "x": 6,
            "y": 3,
            "z": 1
        },
        "key": "2_IsM",
        "tag": "badspawn"
    },
    "Cm8L4": {
        "position": {
            "x": 7,
            "y": 3,
            "z": 1
        },
        "key": "Cm8L4",
        "tag": "badspawn"
    },
    "9q3_f": {
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        },
        "key": "9q3_f",
        "tag": "goodspawn"
    },
    "woTvC": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "key": "woTvC",
        "tag": "goodspawn"
    },
    "EgMQu": {
        "position": {
            "x": 9,
            "y": 6,
            "z": 1
        },
        "key": "EgMQu",
        "tag": "goodspawn"
    },
    "YW-YD": {
        "position": {
            "x": 6,
            "y": 6,
            "z": 1
        },
        "key": "YW-YD",
        "tag": "goodspawn"
    },
    "UVL73": {
        "position": {
            "x": 7,
            "y": 2,
            "z": 1
        },
        "key": "UVL73",
        "tag": "badspawn"
    },
    "icSej": {
        "position": {
            "x": 8,
            "y": 3,
            "z": 1
        },
        "key": "icSej",
        "tag": "badspawn"
    },
    "UbzWy": {
        "position": {
            "x": 9,
            "y": 3,
            "z": 1
        },
        "key": "UbzWy",
        "tag": "badspawn"
    },
    "d6gfN": {
        "position": {
            "x": 8,
            "y": 4,
            "z": 1
        },
        "key": "d6gfN",
        "tag": "badspawn"
    },
    "04HAA": {
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        },
        "key": "04HAA",
        "tag": "badspawn"
    },
    "Aonsa": {
        "position": {
            "x": 5,
            "y": 3,
            "z": 1
        },
        "key": "Aonsa",
        "tag": "badspawn"
    }
}